import React from 'react'
import { useQuery } from 'react-query'
import { getOrders } from '../../../../MyApi/orders'
import DataTable from '../../../UI/table/DataTable'

import TableActions from '../../../UI/table/TableActions'
import StatusBadge from '../../../orders/show/statusbadge'

const CuriorsOrders = ({id ,storeId ,isUser}) => {
    const {data ,isLoading}=useQuery("getOrders",()=>getOrders( storeId,id ,"",isUser))  
    const orders =data?.data?.orders ||[]
 const columns = [
  { label: "معرف الطلب ", render:(row)=> <div className='text-green'>{row.order_number} </div>  },

  { label: "العميل", accessor: "user.name" },
  { label: "المتجر", accessor: "store.name" },
  { label: "المبلغ المستحق", accessor: "pricing.final_amount" },


  {
    label: "الحالة",
    render: (row) => (
      <StatusBadge status={row.status.value } />
    ),
  },
  {
    label: "الإجراءات",
    render: (row) => <TableActions show={`/orders/${row.id}`}  viewPermission={"view_order"}/>,
  },
];


  return (  
    <div>
        <DataTable data={orders} columns={columns} isLoading={isLoading}/>
    </div>
  )
}

export default CuriorsOrders